import { BaseEdge, EdgeLabelRenderer } from 'reactflow';

import { EdgePlusButton, OnPlusClick } from './EdgePlusButton';
import styles from './EdgeTypes.module.scss';
import { useReactFlow } from '../functions';
import { EdgeProps } from '../types';
import { Y_AXIS_SPACER as yAxisSpacer, BORDER_RADIUS as borderRadius } from '@/react_app/components/ReactFlow/EdgeTypes';
import * as WorkflowNodeService from '@/utils/workflow-node-service';

export default function WorkflowBranchEdge({ data, id, sourceX, sourceY, targetX, targetY, style }: EdgeProps) {
	const { getEdge } = useReactFlow();
	const edge = getEdge(id);
	if (!edge) {
		throw new Error('Edge not found');
	}
	const branchName = data?.branchPath?.name;
	const onClick: OnPlusClick = (shortcut) => {
		data?.onClick(edge, shortcut);
	};

	const isMoveNodeActive = !!data?.isMoveNodeActive;
	const isTempBlockInvolved = WorkflowNodeService.isNodeTemp({ id });
	const showPlusButton = !isTempBlockInvolved && !!data?.isAllowedToEdit;

	const turningPointY = sourceY + yAxisSpacer;
	const isTargetXGreaterThanSourceX = targetX > sourceX;

	const edgePath = `M${sourceX} ${sourceY}
	L${sourceX} ${sourceY + yAxisSpacer}
	L${sourceX} ${turningPointY}
	Q${sourceX} ${turningPointY} ${sourceX + (isTargetXGreaterThanSourceX ? borderRadius : -borderRadius)} ${turningPointY}
	L${targetX - (isTargetXGreaterThanSourceX ? borderRadius : -borderRadius)} ${turningPointY}
	Q${targetX} ${turningPointY} ${targetX} ${turningPointY + borderRadius}
	L${targetX} ${targetY}`;

	return (
		<>
			<BaseEdge id={id} path={edgePath} style={style} />
			<EdgeLabelRenderer>
				<div
					style={{
						position: 'absolute',
						transform: `translate(-50%, 0%) translate(${targetX}px, ${sourceY + 40}px)`,
					}}
					className="nodrag nopan"
				>
					<div className="flex-centerize">
						<div className={styles.addStepText}>{branchName}</div>
						{showPlusButton && (
							<div style={{ position: 'absolute', marginTop: '60px' }}>
								<EdgePlusButton onPlusClick={onClick} isMoveNodeActive={isMoveNodeActive} />
							</div>
						)}
					</div>
				</div>
			</EdgeLabelRenderer>
		</>
	);
}
